import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getCategories } from "../../api/woocommerce";

export default function ProductFilters({ filters, onUpdate }) {
    const [categories, setCategories] = useState([]);
    const [minPrice, setMinPrice] = useState(filters.minPrice || "");
    const [maxPrice, setMaxPrice] = useState(filters.maxPrice || "");

    useEffect(() => {
        getCategories().then(setCategories).catch(console.error);
    }, []);

    const applyPrice = () => {
        onUpdate({ minPrice, maxPrice });
    };

    return (
        <div className="flex flex-col gap-6">
            {/* Categories */}
            <div>
                <h4 className="text-sm font-bold text-neutral-800 mb-3 uppercase tracking-wide">
                    Categories
                </h4>
                <ul className="flex flex-col gap-1">
                    <li>
                        <button
                            onClick={() => onUpdate({ category: "" })}
                            className={`w-full text-left text-sm px-2 py-1.5 rounded-lg transition-colors
                ${!filters.category ? "bg-primary-50 text-primary-700 font-semibold" : "text-neutral-600 hover:bg-neutral-100"}`}
                        >
                            All Products
                        </button>
                    </li>
                    {categories.map((cat) => (
                        <li key={cat.id}>
                            <button
                                onClick={() => onUpdate({ category: cat.slug })}
                                className={`w-full text-left text-sm px-2 py-1.5 rounded-lg transition-colors flex items-center justify-between
                  ${filters.category === cat.slug ? "bg-primary-50 text-primary-700 font-semibold" : "text-neutral-600 hover:bg-neutral-100"}`}
                            >
                                <span>{cat.name}</span>
                                <span className="text-xs text-neutral-400">
                                    {cat.count}
                                </span>
                            </button>
                        </li>
                    ))}
                </ul>
            </div>

            {/* Price Range */}
            <div>
                <h4 className="text-sm font-bold text-neutral-800 mb-3 uppercase tracking-wide">
                    Price Range
                </h4>
                <div className="flex gap-2 items-center">
                    <input
                        type="number"
                        className="input text-sm py-1.5 px-2"
                        placeholder="Min"
                        value={minPrice}
                        min={0}
                        onChange={(e) => setMinPrice(e.target.value)}
                    />
                    <span className="text-neutral-400 shrink-0">–</span>
                    <input
                        type="number"
                        className="input text-sm py-1.5 px-2"
                        placeholder="Max"
                        value={maxPrice}
                        min={0}
                        onChange={(e) => setMaxPrice(e.target.value)}
                    />
                </div>
                <button
                    onClick={applyPrice}
                    className="btn-primary w-full mt-3 text-sm py-2"
                >
                    Apply Price
                </button>
                {(filters.minPrice || filters.maxPrice) && (
                    <button
                        onClick={() => {
                            setMinPrice("");
                            setMaxPrice("");
                            onUpdate({ minPrice: "", maxPrice: "" });
                        }}
                        className="text-xs text-neutral-400 hover:text-neutral-600 underline mt-2 block"
                    >
                        Clear price filter
                    </button>
                )}
            </div>

            {/* Availability */}
            <div>
                <h4 className="text-sm font-bold text-neutral-800 mb-3 uppercase tracking-wide">
                    Availability
                </h4>
                <label className="flex items-center gap-2 cursor-pointer">
                    <input
                        type="checkbox"
                        className="w-4 h-4 accent-primary-600"
                        checked={filters.inStock || false}
                        onChange={(e) =>
                            onUpdate({ inStock: e.target.checked })
                        }
                    />
                    <span className="text-sm text-neutral-600">
                        In Stock Only
                    </span>
                </label>
            </div>
        </div>
    );
}
